export const categories = [
  { slug: 'shaonian', name: '少年漫画', icon: 'ri-sword-line', count: 156 },
  { slug: 'rexie', name: '热血漫画', icon: 'ri-fire-line', count: 89 },
  { slug: 'xiaoyuan', name: '校园漫画', icon: 'ri-book-open-line', count: 72 },
  { slug: 'qihuan', name: '奇幻漫画', icon: 'ri-magic-line', count: 103 },
  { slug: 'maoxian', name: '冒险漫画', icon: 'ri-compass-3-line', count: 64 },
  { slug: 'gaoxiao', name: '搞笑漫画', icon: 'ri-emotion-laugh-line', count: 48 },
  { slug: 'kehuan', name: '科幻漫画', icon: 'ri-rocket-line', count: 55 },
  { slug: 'xuanyi', name: '悬疑漫画', icon: 'ri-search-eye-line', count: 37 },
  { slug: 'lianai', name: '恋爱漫画', icon: 'ri-heart-line', count: 61 },
  { slug: 'dongzuo', name: '动作漫画', icon: 'ri-flashlight-line', count: 44 },
];

export const comics = [
  {
    id: 1,
    title: '蜜桃少年',
    author: '林小风',
    category: 'shaonian',
    status: '连载中',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20style%20illustration%20of%20a%20handsome%20teenage%20boy%20with%20warm%20peach%20colored%20background%2C%20anime%20art%20style%2C%20soft%20lighting%2C%20gentle%20expression%2C%20clean%20composition%2C%20manga%20cover%20aesthetic%2C%20pastel%20tones%2C%20dreamy%20atmosphere&width=800&height=1067&seq=comic-cover-01&orientation=portrait',
    description: '一个普通高中生的日常生活，却因为一只神秘的蜜桃而发生了翻天覆地的变化。少年林泽在偶然间获得了一颗神奇的蜜桃，从此踏上了一段充满奇幻与冒险的成长之旅。',
    rating: 9.5,
    views: 1280000,
    chapters: 156,
    updatedAt: '2026-07-02',
    tags: ['少年', '奇幻', '成长', '校园'],
    chapters_list: [
      { num: 156, title: '新的开始', date: '2026-07-02' },
      { num: 155, title: '最后的考验', date: '2026-06-30' },
      { num: 154, title: '伙伴的力量', date: '2026-06-28' },
      { num: 153, title: '黑暗降临', date: '2026-06-26' },
      { num: 152, title: '意外的援军', date: '2026-06-24' },
    ],
    featured: true,
    hot: true,
  },
  {
    id: 2,
    title: '星辰之海',
    author: '云中子',
    category: 'maoxian',
    status: '连载中',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20adventure%20illustration%20of%20a%20young%20explorer%20in%20a%20starry%20ocean%20world%2C%20anime%20style%2C%20deep%20blue%20and%20gold%20color%20scheme%2C%20mysterious%20atmosphere%2C%20manga%20cover%20design%2C%20celestial%20motifs&width=800&height=1067&seq=comic-cover-02&orientation=portrait',
    description: '在遥远的未来，人类已经征服了星辰大海。少年船长叶星辰带领着他的船员们，驾驶着星际飞船探索未知的宇宙深处，揭开一个又一个文明的秘密。',
    rating: 9.3,
    views: 890000,
    chapters: 98,
    updatedAt: '2026-07-01',
    tags: ['冒险', '科幻', '星际', '热血'],
    chapters_list: [
      { num: 98, title: '黑洞边缘', date: '2026-07-01' },
      { num: 97, title: '未知信号', date: '2026-06-29' },
      { num: 96, title: '外星遗迹', date: '2026-06-27' },
      { num: 95, title: '星际风暴', date: '2026-06-25' },
      { num: 94, title: '新的航向', date: '2026-06-23' },
    ],
    featured: true,
    hot: true,
  },
  {
    id: 3,
    title: '樱花树下的约定',
    author: '苏小暖',
    category: 'xiaoyuan',
    status: '已完结',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20romantic%20school%20life%20illustration%20under%20cherry%20blossom%20tree%2C%20anime%20style%2C%20soft%20pink%20and%20white%20color%20palette%2C%20gentle%20spring%20atmosphere%2C%20manga%20cover%20aesthetic%2C%20youthful%20romance&width=800&height=1067&seq=comic-cover-03&orientation=portrait',
    description: '高二开学第一天，转学生林小雨在樱花树下遇到了一个神秘的少年。樱花飘落的季节，青春的故事悄然展开，一段纯真的校园恋情就此萌芽。',
    rating: 9.2,
    views: 1560000,
    chapters: 120,
    updatedAt: '2026-06-15',
    tags: ['校园', '恋爱', '青春', '治愈'],
    chapters_list: [
      { num: 120, title: '永远在一起（终章）', date: '2026-06-15' },
      { num: 119, title: '樱花再开', date: '2026-06-13' },
      { num: 118, title: '毕业季', date: '2026-06-11' },
      { num: 117, title: '告白', date: '2026-06-09' },
      { num: 116, title: '误会', date: '2026-06-07' },
    ],
    featured: true,
    hot: false,
  },
  {
    id: 4,
    title: '黑暗纪元',
    author: '墨渊',
    category: 'rexie',
    status: '连载中',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20dark%20fantasy%20action%20illustration%20of%20a%20warrior%20teen%20with%20glowing%20sword%2C%20anime%20style%2C%20dramatic%20lighting%2C%20dark%20crimson%20and%20black%20tones%2C%20epic%20manga%20cover%20design%2C%20intense%20atmosphere&width=800&height=1067&seq=comic-cover-04&orientation=portrait',
    description: '黑暗势力席卷大陆，人类面临前所未有的危机。少年剑客韩枫背负着家族的使命，手持传说中的神剑，踏上了斩妖除魔的征途。',
    rating: 9.4,
    views: 2100000,
    chapters: 203,
    updatedAt: '2026-07-03',
    tags: ['热血', '战斗', '奇幻', '冒险'],
    chapters_list: [
      { num: 203, title: '最终决战前夜', date: '2026-07-03' },
      { num: 202, title: '神剑觉醒', date: '2026-07-01' },
      { num: 201, title: '魔王的真面目', date: '2026-06-29' },
      { num: 200, title: '联盟集结', date: '2026-06-27' },
      { num: 199, title: '突破极限', date: '2026-06-25' },
    ],
    featured: false,
    hot: true,
  },
  {
    id: 5,
    title: '天才魔法师',
    author: '蓝夜',
    category: 'qihuan',
    status: '连载中',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20fantasy%20magic%20illustration%20of%20a%20young%20mage%20casting%20spells%2C%20anime%20style%2C%20vibrant%20magical%20effects%2C%20purple%20and%20silver%20color%20palette%2C%20mystical%20atmosphere%2C%20manga%20cover%20aesthetic&width=800&height=1067&seq=comic-cover-05&orientation=portrait',
    description: '被认为没有魔法天赋的少年艾伦，在一次意外中觉醒了远古的魔法血脉。从此他的人生彻底改变，成为了大陆上最耀眼的魔法天才。',
    rating: 9.1,
    views: 980000,
    chapters: 167,
    updatedAt: '2026-07-02',
    tags: ['奇幻', '魔法', '成长', '学院'],
    chapters_list: [
      { num: 167, title: '远古龙族', date: '2026-07-02' },
      { num: 166, title: '禁术奥义', date: '2026-06-30' },
      { num: 165, title: '魔法对决', date: '2026-06-28' },
      { num: 164, title: '学院比赛', date: '2026-06-26' },
      { num: 163, title: '新来的转学生', date: '2026-06-24' },
    ],
    featured: false,
    hot: true,
  },
  {
    id: 6,
    title: '笑傲校园',
    author: '逗比君',
    category: 'gaoxiao',
    status: '连载中',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20comedy%20school%20illustration%20of%20funny%20teenage%20characters%2C%20anime%20style%2C%20bright%20cheerful%20colors%2C%20humorous%20expression%2C%20manga%20cover%20design%2C%20lively%20classroom%20setting&width=800&height=1067&seq=comic-cover-06&orientation=portrait',
    description: '全校最搞笑的班级——高一三班，每天都在上演令人捧腹大笑的故事。班主任是个不靠谱的年轻人，学生们个个都是活宝。',
    rating: 8.9,
    views: 670000,
    chapters: 88,
    updatedAt: '2026-07-01',
    tags: ['搞笑', '校园', '日常', '轻松'],
    chapters_list: [
      { num: 88, title: '运动会风波', date: '2026-07-01' },
      { num: 87, title: '考试作弊大作战', date: '2026-06-29' },
      { num: 86, title: '食堂争夺战', date: '2026-06-27' },
      { num: 85, title: '班主任的秘密', date: '2026-06-25' },
      { num: 84, title: '校园怪谈', date: '2026-06-23' },
    ],
    featured: false,
    hot: false,
  },
  {
    id: 7,
    title: '未来战记',
    author: '铁血',
    category: 'kehuan',
    status: '连载中',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20sci-fi%20mecha%20illustration%20of%20a%20young%20pilot%20with%20giant%20robot%2C%20anime%20style%2C%20metallic%20blue%20and%20silver%20color%20scheme%2C%20futuristic%20city%20background%2C%20manga%20cover%20design&width=800&height=1067&seq=comic-cover-07&orientation=portrait',
    description: '公元2150年，人类与外星文明爆发了全面战争。少年机师林枫驾驶着最强机甲"破晓"，在战火中守护着人类最后的希望。',
    rating: 9.0,
    views: 750000,
    chapters: 134,
    updatedAt: '2026-07-02',
    tags: ['科幻', '机甲', '战争', '热血'],
    chapters_list: [
      { num: 134, title: '敌军总攻', date: '2026-07-02' },
      { num: 133, title: '新型机甲', date: '2026-06-30' },
      { num: 132, title: '潜入敌营', date: '2026-06-28' },
      { num: 131, title: '背叛者', date: '2026-06-26' },
      { num: 130, title: '反击开始', date: '2026-06-24' },
    ],
    featured: false,
    hot: false,
  },
  {
    id: 8,
    title: '迷雾之城',
    author: '夜行者',
    category: 'xuanyi',
    status: '连载中',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20mystery%20thriller%20illustration%20of%20a%20detective%20teen%20in%20foggy%20city%2C%20anime%20style%2C%20dark%20moody%20tones%2C%20suspenseful%20atmosphere%2C%20manga%20cover%20design%2C%20noir%20aesthetic&width=800&height=1067&seq=comic-cover-08&orientation=portrait',
    description: '一座被迷雾笼罩的城市，每月都会发生离奇的失踪案件。高中生侦探顾北辰凭借敏锐的观察力，一步步揭开了迷雾背后惊人的真相。',
    rating: 9.3,
    views: 520000,
    chapters: 67,
    updatedAt: '2026-06-30',
    tags: ['悬疑', '推理', '都市', '惊悚'],
    chapters_list: [
      { num: 67, title: '第十三起失踪', date: '2026-06-30' },
      { num: 66, title: '目击证人', date: '2026-06-28' },
      { num: 65, title: '地下通道', date: '2026-06-26' },
      { num: 64, title: '关键线索', date: '2026-06-24' },
      { num: 63, title: '新的案件', date: '2026-06-22' },
    ],
    featured: false,
    hot: false,
  },
  {
    id: 9,
    title: '武道至尊',
    author: '战神',
    category: 'dongzuo',
    status: '连载中',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20martial%20arts%20action%20illustration%20of%20a%20young%20fighter%20in%20dynamic%20pose%2C%20anime%20style%2C%20fiery%20orange%20and%20red%20color%20palette%2C%20intense%20battle%20atmosphere%2C%20manga%20cover%20design&width=800&height=1067&seq=comic-cover-09&orientation=portrait',
    description: '出身贫寒的少年武辰，凭借不屈的意志和惊人的天赋，在武道世界中一路崛起。从一个默默无闻的小角色，成长为万人敬仰的武道至尊。',
    rating: 9.4,
    views: 1890000,
    chapters: 245,
    updatedAt: '2026-07-03',
    tags: ['动作', '武道', '热血', '成长'],
    chapters_list: [
      { num: 245, title: '天下第一武道会', date: '2026-07-03' },
      { num: 244, title: '突破瓶颈', date: '2026-07-01' },
      { num: 243, title: '宿敌之战', date: '2026-06-29' },
      { num: 242, title: '师父的遗愿', date: '2026-06-27' },
      { num: 241, title: '新的境界', date: '2026-06-25' },
    ],
    featured: false,
    hot: true,
  },
  {
    id: 10,
    title: '甜蜜契约',
    author: '糖果小姐',
    category: 'lianai',
    status: '已完结',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20sweet%20romance%20illustration%20of%20a%20couple%20in%20modern%20city%2C%20anime%20style%2C%20warm%20pastel%20pink%20and%20cream%20color%20palette%2C%20romantic%20atmosphere%2C%20manga%20cover%20aesthetic&width=800&height=1067&seq=comic-cover-10&orientation=portrait',
    description: '因为一份意外的契约，高冷学霸顾言和活泼少女沈甜开始了同居生活。从互看不顺眼到彼此心动，甜蜜的恋爱故事就此展开。',
    rating: 9.0,
    views: 1340000,
    chapters: 96,
    updatedAt: '2026-05-20',
    tags: ['恋爱', '校园', '甜宠', '日常'],
    chapters_list: [
      { num: 96, title: '幸福的约定（终章）', date: '2026-05-20' },
      { num: 95, title: '求婚', date: '2026-05-18' },
      { num: 94, title: '见家长', date: '2026-05-16' },
      { num: 93, title: '表白之夜', date: '2026-05-14' },
      { num: 92, title: '误会解除', date: '2026-05-12' },
    ],
    featured: false,
    hot: false,
  },
  {
    id: 11,
    title: '灵界探险队',
    author: '幽灵船长',
    category: 'maoxian',
    status: '连载中',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20supernatural%20adventure%20illustration%20of%20teenage%20explorers%20in%20spirit%20world%2C%20anime%20style%2C%20ethereal%20green%20and%20gold%20colors%2C%20mysterious%20atmosphere%2C%20manga%20cover%20design&width=800&height=1067&seq=comic-cover-11&orientation=portrait',
    description: '五个拥有特殊能力的少年，组成了灵界探险队。他们在现实世界与灵界的夹缝中冒险，解决各种超自然事件，守护两个世界的平衡。',
    rating: 8.8,
    views: 430000,
    chapters: 55,
    updatedAt: '2026-06-29',
    tags: ['冒险', '灵异', '超能力', '团队'],
    chapters_list: [
      { num: 55, title: '灵界之门', date: '2026-06-29' },
      { num: 54, title: '第五位成员', date: '2026-06-27' },
      { num: 53, title: '诅咒之源', date: '2026-06-25' },
      { num: 52, title: '恶灵附身', date: '2026-06-23' },
      { num: 51, title: '午夜学校', date: '2026-06-21' },
    ],
    featured: false,
    hot: false,
  },
  {
    id: 12,
    title: '剑道无双',
    author: '竹中剑',
    category: 'rexie',
    status: '连载中',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20swordsman%20action%20illustration%20of%20a%20young%20samurai%20in%20battle%2C%20anime%20style%2C%20sharp%20silver%20and%20dark%20blue%20tones%2C%20dynamic%20pose%2C%20manga%20cover%20design%2C%20epic%20composition&width=800&height=1067&seq=comic-cover-12&orientation=portrait',
    description: '剑道世家出身的少年柳生一心，为了追寻剑道的极致而踏上修行之路。在无数次的生死对决中，他逐渐领悟了真正的剑道精神。',
    rating: 9.2,
    views: 1120000,
    chapters: 178,
    updatedAt: '2026-07-02',
    tags: ['热血', '剑道', '修行', '竞技'],
    chapters_list: [
      { num: 178, title: '剑圣之名', date: '2026-07-02' },
      { num: 177, title: '终极奥义', date: '2026-06-30' },
      { num: 176, title: '宿命之战', date: '2026-06-28' },
      { num: 175, title: '绝境突破', date: '2026-06-26' },
      { num: 174, title: '全国大赛', date: '2026-06-24' },
    ],
    featured: false,
    hot: false,
  },
];

export const getComicById = (id: number) => comics.find(c => c.id === id);
export const getComicsByCategory = (slug: string) => comics.filter(c => c.category === slug);
export const getFeaturedComics = () => comics.filter(c => c.featured);
export const getHotComics = () => comics.filter(c => c.hot);
export const getLatestComics = () => [...comics].sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime());
export const getTopRatedComics = () => [...comics].sort((a, b) => b.rating - a.rating);
export const getCategoryBySlug = (slug: string) => categories.find(c => c.slug === slug);